/**
 * Devis. La liste, la révision et l'annulation sont au bureau ; préparer,
 * relire et faire signer un devis se fait aussi sur place (Q36). Facturer un
 * devis accepté suit le droit des factures (refonte v4 du 17/10/2026).
 */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const QuotesPage = lazy(() => import('./QuotesPage.js').then((m) => ({ default: m.QuotesPage })));
const QuoteDetailPage = lazy(() => import('./QuoteDetailPage.js').then((m) => ({ default: m.QuoteDetailPage })));
const QuoteSendPage = lazy(() => import('./QuoteSendPage.js').then((m) => ({ default: m.QuoteSendPage })));
const QuoteInvoicePage = lazy(() => import('./QuoteInvoicePage.js').then((m) => ({ default: m.QuoteInvoicePage })));
const DocumentEditorPage = lazy(() => import('../documents/DocumentEditorPage.js').then((m) => ({ default: m.DocumentEditorPage })));
const DocumentEmailPage = lazy(() => import('../documents/DocumentActions.js').then((m) => ({ default: m.DocumentEmailPage })));

const manage = { anyOf: ['quote.manage'] } as const;
/** Préparer, relire et envoyer un devis : le bureau, ou le terrain dans ses limites. */
const prepare = { anyOf: ['quote.manage', 'quote.send_within_limits'] } as const;

export const quotesRoutes: AppRoute[] = [
  { path: '/devis', element: <QuotesPage />, gate: manage },
  { path: '/devis/nouveau', element: <DocumentEditorPage kind="quote" mode="new" />, gate: prepare },
  { path: '/devis/:id', element: <QuoteDetailPage />, gate: prepare },
  { path: '/devis/:id/modifier', element: <DocumentEditorPage kind="quote" mode="edit" />, gate: manage },
  { path: '/devis/:id/revision', element: <DocumentEditorPage kind="quote" mode="revise" />, gate: manage },
  { path: '/devis/:id/envoi', element: <QuoteSendPage />, gate: prepare },
  { path: '/devis/:id/envoi-email', element: <DocumentEmailPage kind="quote" />, gate: manage },
  { path: '/devis/:id/facturer', element: <QuoteInvoicePage />, gate: { anyOf: ['invoice.manage'] } },
];
